/**
 * UI Constants for Game Components
 * Centralizes magic numbers and styling values for maintainability
 */

// Player Info Layout Constants
export const PLAYER_INFO = {
  AVATAR_SIZE: 45,
  CARD_HEIGHT: 55,
  CARD_PADDING: 6,
  CARD_BORDER_RADIUS: 6,
  CARD_GAP: 8,
  NAME_MAX_WIDTH: 90,
  COLOR_INDICATOR_SIZE: 12, // w-3 h-3 (12px)
  COLOR_INDICATOR_BORDER_WIDTH: 2
} as const;

// Typography Constants
export const TYPOGRAPHY = {
  PLAYER_NAME_SIZE: 11,
  PIP_COUNT_SIZE: 10,
  CUBE_ICON_SIZE: 10,
  NAME_BANNER_PADDING_Y: 2,
  NAME_BANNER_PADDING_X: 4,
  NAME_BANNER_BORDER_RADIUS: 3
} as const;

// Sidebar Layout Constants
export const SIDEBAR = {
  WIDTH: 160, // w-40 in Tailwind
  PADDING: 8 // p-2 in Tailwind
} as const;

// Animation Constants
export const ANIMATIONS = {
  TURN_TRANSITION_DURATION: 200, // 0.2s in milliseconds
  INACTIVE_OPACITY: 0.85
} as const;

// Color Constants (Tailwind color values for consistency)
export const PLAYER_COLORS = {
  WHITE_INDICATOR_BG: "#e5e7eb", // gray-200
  BLACK_INDICATOR_BG: "#1f2937", // gray-800
  WHITE_INDICATOR_BORDER: "#0f172a", // slate-900
  BLACK_INDICATOR_BORDER: "#9ca3af", // gray-400
  TURN_ACTIVE_COLOR: "#f97316", // orange-500
  CUBE_ICON_COLOR: "#fb923c" // orange-400
} as const;

// Game Info Row Constants
export const GAME_INFO = {
  ROW_GAP: 4,
  CUBE_PADDING_LEFT: 4
} as const;
